import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  IOrganization,
  IOrganizationDetailList,
  IOrganizationDetails,
  IULB,
  IUserContext,
} from './common-model';
import { tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class GlobalService {
 private readonly baseUrl: string = 'https://tnurbanepay.tn.gov.in/api/';
 //private readonly baseUrl: string = 'http://localhost:52737/api/';
  regionList: IOrganization[] = [];
  corporationList: IOrganization[] = [];
  municipalityList: IULB[] = [];

  constructor(private _http: HttpClient) {}

  getSchemeWiseDetails(): Observable<IOrganizationDetailList[]> {
    return this._http
      .get<IOrganizationDetailList[]>(
        // `${this.baseUrl}WW_Dashboard/OrgViewDetails`
        `${this.baseUrl}Scheme_DB/OrgViewDetailsScheme?schemeid=0`
      )
      .pipe(
        tap((data) => {
          this.regionList = [];
          this.municipalityList = [];

          this.corporationList = [];

          this.municipalityList = data.filter((data) => {
            return data.OrganizationTypeID === 8;
          });

          this.municipalityList = this.municipalityList.sort(function (a, b) {
            return a.MuncipalityName.localeCompare(b.MuncipalityName);
          });

          const myClonedArrayCorp = Object.assign([], this.municipalityList);

          const arrayUniqueByKey = [
            ...new Map(
              myClonedArrayCorp.map((item) => [item['RegionID'], item])
            ).values(),
          ];

          this.regionList = arrayUniqueByKey;

          this.regionList = this.regionList.sort(function (a, b) {
            return a.RegionName.localeCompare(b.RegionName);
          });

          this.regionList.unshift({
            OrganizationTypeID: 8,
            RegionID: 0,
            RegionName: 'Overall Region',
            SmartCity: 0,
          });

          this.corporationList = data
            .filter((data) => {
              return data.OrganizationTypeID === 6;
            })
            .map((result) => {
              console.log(result.SmartCity);
              result.SmartCity = result.SmartCity;
              return result;
            });

          this.corporationList = this.corporationList
            .sort(function (a, b) {
              return a.RegionName.localeCompare(b.RegionName);
            })
            .sort((a, b) => {
              return Number(a.SmartCity) - Number(b.SmartCity);
            });

          // this.corporationList.unshift({
          //   OrganizationTypeID: 6,
          //   RegionID: 0,
          //   RegionName: 'Overall Corporation',
          //   SmartCity: true,
          // });

          let orgDetails: IOrganizationDetails = {
            regionDetail: this.regionList,
            corporationDetail: this.corporationList,
            municipalityDetail: this.municipalityList,
          };

          sessionStorage.setItem(
            'organizationList',
            JSON.stringify(orgDetails)
          );
        })
      );
  }

  getUserContext(
    Username: string,
    Password: any
  ): Observable<IUserContext[]> 
  {
    return this._http.get<IUserContext[]>(
      `${this.baseUrl}Scheme_DB/LoginCheck?Username=${Username}&Password=${Password}`
    );

    //const url = `${this.baseUrl}Scheme_DB/LoginCheck`
    //const url = `${this.baseUrl}Scheme_DB/LoginCheck?Username=${Username}&Password=${encodeURIComponent(Password)}`
    //return this._http.post<IUserContext[]>(url, {Username:Username,Password:Password})


  }
  getUserContext_post(
    Username: string,
    Password: any
  ): Observable<IUserContext[]> 
  {
    return this._http.get<IUserContext[]>(
      `${this.baseUrl}Scheme_DB/LoginCheck?Username=${Username}&Password=${Password}`
    );

    //const url = `${this.baseUrl}Scheme_DB/LoginCheck`
    //const url = `${this.baseUrl}Scheme_DB/LoginCheck?Username=${Username}&Password=${encodeURIComponent(Password)}`
    //return this._http.post<IUserContext[]>(url, {Username:Username,Password:Password})


  }
}
